export default __webpack_public_path__ + "static/media/logo.1a1cd155.svg";